// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { FormattedText } = require('core/i18n').i18n;

// @helppers
const { toCamelCase } = require('utilities/stringHelper');
const { getFormattedLanguage } = require('mifid/utilities/mifidLanguageHelper');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @commponents
const Avatar = require('components/avatar/avatar');
const { OKCover } = require('commonsComponents/OKCover');

// @constants
const { LANGUAGE_ES } = require('mifid/constants/constants');

//@utils
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');


class BrokerConvenienceTestHeader extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogoClick = this.handleLogoClick.bind(this);
    }

    handleLogoClick() {
        this.props.history.push('/myprofile/broker');
    }

    render() {
        const { immProfile, immBrokerConvenienceMiFIDTest  } = this.props;

        const alias =
            immProfile.get('alias').trim() ||
            toCamelCase(immProfile.get('nombreCliente').trim());
        const avatarUrl = immProfile.get('avatar');

        let avatar;
        if (avatarUrl && !immProfile.get('isFetching')) {
            avatar = (
                <Avatar
                    imgDescription="avatar-robo-advisor-header"
                    imgType="header-mode"
                    imgUrl={avatarUrl}
                    id="avatar-robo-advisor-header"
                />
            );
        }

        const okCoverClassName = classNames('col-xs-12', {
            'br-convenience-test-view__cover': !__CONTACT_CENTER__,
        });
        const language = getFormattedLanguage();
        const logo = language === LANGUAGE_ES ? 'es' : 'en';
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])
        const isPrivateEquity = isPrivateEquityTest(testToEvaluateId);

        const titleText = isPrivateEquity ? 'broker-convenienceMifidTest_title_privateEquity' : 'broker-convenienceMifidTest_title';

        return (
            <OKCover section="generic" customClass={okCoverClassName}>
                <div className="br-convenience-test-view__header-container">
                    <div className="br-convenience-test-view__header-left-container">
                        <i
                            onClick={this.handleLogoClick}
                            className={`br-convenience-test-view__header-logo-${logo}`}
                        />
                        <div className="br-convenience-test-view__header-title">
                            <FormattedText value={titleText} />
                        </div>

                    </div>
                    <div className="br-convenience-test-view__header-right-container">
                        <div className="br-convenience-test-view__header-avatar-container">
                            {avatar}
                        </div>
                        <div className="br-convenience-test-view__header-alias">
                            {alias}
                        </div>
                    </div>
                </div>
            </OKCover>
        );
    }
}

BrokerConvenienceTestHeader.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = connect(state => ({
    immProfile: state.profile,
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
}), {})(BrokerConvenienceTestHeader);
